<template>
<div class="copy-popup-background" @click="close($event)">
    <div class="copy-popup">
        <div class="copy-popup__body">
            <div v-if="!pageOnly" class="popup-group">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <h1>Kopiuj do:</h1>
                    <div class="row row-checkboxes">
                        <div class="col-6">
                            <div class="form-group">
                                <label class="checkbox"><input type="checkbox" v-model="otherOrder" @change="checkBox('other')"/><span class="checkmark"></span>innego zlecenia</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group" :class="{'disabled' : disable.currentOrder}">
                                <label class="checkbox"><input type="checkbox" v-model="currentOrder" @change="checkBox('current')"/><span class="checkmark"></span>bieżącego zlecenia</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-3">
                            <div class="form-group" style="position:relative;" :class="{ 'input-error': $v.copy.name.$error}">
                                <label>nazwa zlecenia*</label>
                                <input class="form-control form-control-lg custom-search-input" :class="{'disabled' : disable.search}" type="text" v-model="copy.name" @input="searching()" @focus="showSelectList($event)"/>
                                <img class ="form-group__icon" src="@/assets/symbols/search.svg">
                                <div class="select-search">
                                    <ul>
                                        <li v-for="order in orders" :key="order.id" :style="{'display' : order.id == orderId ? 'none' : ''}" @click="copy.selectedOrderId = order.id; copy.name = `${order.number} ${order.name}`">
                                            {{order.number}} {{order.name}}
                                        </li>
                                    </ul>
                                </div>
                                <labelInfo v-if="!$v.copy.name.required" type="error" message="To pole jest wymagane"/>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="form-group" :class="{ 'input-error': $v.copy.number.$error}">
                                <label>nowy numer artykułu*</label>
                                <input class="form-control form-control-lg" :class="{'disabled' : disable.number || copy.temporary}" type="text" v-model="copy.number"/>
                                <labelInfo v-if="!$v.copy.number.numeric" type="error" message="To pole musi być liczbą"/>
                                <labelInfo v-if="!$v.copy.number.maxLength" type="error" message="Liczba jest za duża"/>
                            </div>
                        </div>
                        <div class="col-4 col-temporary">
                            <div class="form-group" :class="{'disabled' : disable.temporary}">
                                <label class="checkbox"><input type="checkbox" v-model="copy.temporary" @click="copy.number = ''"/><span class="checkmark"></span>Tymczasowy</label>
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="form-group page" :class="{'input-error': $v.copy.pageNumber.$error, 'disabled' : disable.page}">
                                <label>nr strony</label>
                                <input class="form-control form-control-lg" type="text" v-model="copy.pageNumber"/>
                                <labelInfo v-if="!$v.copy.pageNumber.numeric" type="error" message="To pole musi być liczbą"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="pageOnly" class="popup-group">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <h1>Kopiuj stronę / strony do innego zlecenia:</h1>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group" style="position:relative;" :class="{ 'input-error': $v.copy.name.$error}">
                                <label>nazwa zlecenia*</label>
                                <input class="form-control form-control-lg custom-search-input" :class="{'disabled' : disable.search}" type="text" v-model="copy.name" @input="searching()" @focus="showSelectList($event)"/>
                                <img class ="form-group__icon" src="@/assets/symbols/search.svg">
                                <div class="select-search">
                                    <ul>
                                        <li v-for="order in orders" :key="order.id" :style="{'display' : order.id == orderId ? 'none' : ''}" @click="copy.selectedOrderId = order.id; copy.name = `${order.number} ${order.name}`;">
                                            {{order.number}} {{order.name}}
                                        </li>
                                    </ul>
                                </div>
                                <labelInfo v-if="!$v.copy.name.required" type="error" message="To pole jest wymagane"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="popup-group">
                <div class="popup-group__column">
                </div>
                <div class="popup-group__column">
                    <div class="copy-popup__footer">
                        <p v-if="copied">Strona / strony zostały skopiowane</p>
                        <p v-if="copiedProduct">Produkt / produkty zostały skopiowane</p>
                        <p v-if="numberExist">Produkt o wybranym numerze artykułu już istnieje w bazie</p>
                        <button class="button-normal button-normal--media" :class="{'disabled-option' : blockBtn}" @click="copyPageManager()">KOPIUJ</button>
                        <button class="button-normal button-normal--cancel" @click="$emit('cancel')">ANULUJ</button>
                    </div>
                </div>
            </div>
        </div>
      </div>
</div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, numeric, maxLength } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue';
import debounce from "lodash.debounce";
import { setTimeout } from 'timers';

export default {

    name: 'copyPopup',
    components:{

        labelInfo

    },
    props:{

        orderId:{
            type: Number,
            default: 0
        },

        pageId:{
            type: Number,
            default: 0
        },

        selectedItems:{
            type: Array,
            default: () => [],
        },

        selectedPages:{
            type: Array,
            default: () => []
        },

    },
    mixins: [validationMixin],
    data(){

        return{

            products: [],
            images: [],
            statuses: [],

            copiedProduct: false,
            copied: false,
            numberExist: false,

            pageOnly: false,

            copy:{
                name: '',
                number: '',
                pageNumber: '',
                selectedOrderId: '',
                temporary: false,
            },

            disable:{
                temporary: false,
                search: false,
                page: false,
                currentOrder: false,
            },
            
            searchWord: '',
            currentOrder: true,
            otherOrder: false,
            

            orders: [],
            blockBtn: false,

        }

    },
    validations: {

        copy: {
            name:{
                isName(){
                    return this.isName();
                },
            },
            number:{
                numeric,
                maxLength: maxLength(10)
            },
            pageNumber:{
                numeric,
            }
        },

    },
    methods:{

        checkBox(box, stop){

            if(box == 'current' && this.otherOrder){
                 this.currentOrder = true;
                 this.otherOrder = false
            }


            if(box == 'other' && this.currentOrder){
                 this.otherOrder = true;
                 this.currentOrder = false;
                 this.copy.temporary = false;
            }

            if(!stop) this.blockFields();

        },

        isRequired(){

            if(this.copy.temporary){
                return true;
            }

            if(!this.copy.temporary && this.copy.number != ''){
                return true;
            }

            if((this.products.length + this.images.length) > 1){                   
                return true;
            }

            return false;

        },

        isName(){

            if(this.currentOrder && !this.pageOnly){
                return true;
            }

            if(this.otherOrder && this.copy.name != ''){
                return true;
            }

            if(this.pageOnly && this.copy.name != ''){
                return true;
            }

            return false;

        },

        showSelectList(e){
           let list = e.target.parentElement.querySelector('.select-search');

           list.classList.add('active');
        },

        searching: debounce(function(){

            this.searchWord = this.copy.name;
            this.getOrders();

        }, 500),

        getFormData(){

        const token = localStorage.getItem('auth_token');

        this.$http.get('order/form/data', {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                let user = JSON.parse(localStorage.getItem('user'));
                let company;

                if(user.roles[0] == 'ROLE_ADMIN' || user.roles[0] == 'ROLE_SUPER_ADMIN'){
                    company = 'admin';
                }

                if(user.roles[0] == 'ROLE_COORDINATOR' || user.roles[0] == 'ROLE_EDITOR'){
                    company = 'gut';
                }

                if(user.roles[0] == 'ROLE_CENTRAL' || user.roles[0] == 'ROLE_LOCAL'){
                    company = 'mm';
                }

                response.data.status.forEach(status =>{
                    
                    if(company == 'mm'){

                        if(status.code !== 'waiting' && status.code !== 'accept' && status.code !== 'archived' && status.code !== 'cancelled' && status.code !== 'first_gun_build' && status.code !== 'first_correct_gun' && status.code !== 'second_gun_build' && status.code !== 'to_accept'  && status.code !== 'additional_correct_gun'){
                            this.statuses.push(status.id);
                        }

                    }

                    if(company == 'gut' || company == 'admin'){

                        if(status.code !== 'waiting' && status.code !== 'to_accept' && status.code !== 'accept' && status.code !== 'archived' && status.code !== 'cancelled'){
                            this.statuses.push(status.id);
                        }

                    }

                   /* if(company == 'admin'){

                        this.statuses.push(status.id);

                    } */

                })

            })
            .catch(error =>{

                console.error(error.response);

            })

        },

        getOrders(){

            const token = localStorage.getItem('auth_token');

            let request = {
                'limit' : 500,
                'statuses' : this.statuses,
            }

            if(this.$parent.$parent.checkCentralUser()){

                request['ownOrders'] = true;

            }

            if(/\d/.test(this.searchWord)){

                let sWord = this.searchWord.split(' ');
                request['number'] = sWord[0];
                request['name'] = sWord[1];

            }else{

                request['name'] = this.searchWord;

            }

            this.$http.get('order/orders', {
                params:request,
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'

                }})
                .then(response => {

                   this.orders = response.data.list;
                   this.searchWord = '';

                })
                .catch(error =>{
                
                    console.error(error.response);

                })

            },

        copyPageManager(){
            

            this.$v.$touch();

            let valid;

            window.setTimeout(() =>{

                if(document.querySelector('.input-error')){

                this.blockBtn = false;

                }else{

                valid = true;

                }

                if(valid){

                    this.blockBtn = true;

                    if(!this.pageOnly){

                        if(this.otherOrder){
                            this.otherOrderCopy();
                        }

                        if(this.currentOrder && this.copy.number){
                            this.checkNumber();
                        }

                        if(this.currentOrder && !this.copy.number && this.products.length > 0){
                            this.newProduct();
                        }

                        if(this.currentOrder && this.images.length > 0){
                            this.copyImageToOtherPage();
                        }

                    }else{

                        this.otherOrderPage();

                    }

                    this.blockBtn = false;

                }

            }, 100)

        },

        checkNumber(){

            let number = {
                number: this.copy.number
            }

            const token = localStorage.getItem('auth_token');
            
            this.$http.post(`products/is/exists`, number, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                if(response.data.message == false){
                    this.checkNumberInOrder();
                    return;
                }

                this.blockBtn = false;

            })
            .catch(error =>{

                console.error(error.response);
                this.blockBtn = false;

            })

        },

        checkNumberInOrder(){

            let number = {
                number: this.copy.number
            }

            const token = localStorage.getItem('auth_token');
            
            this.$http.post(`orders/${this.orderId}/is/exists/products`, number, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                if(response.data.message == false){
                    this.newProduct();
                    return;
                }

                this.numberExist = true;
                this.blockBtn = false;

            })
            .catch(error =>{

                console.error(error.response);
                this.blockBtn = false;

            })

        },

        otherOrderCopy(){

            const token = localStorage.getItem('auth_token');

            this.$http.get(`orders/${this.copy.selectedOrderId}`, {
                headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
                } }).then(response => {

                this.processToCopy(response.data);

            })

        },

        processToCopy(order){

            const token = localStorage.getItem('auth_token');

            const pages = order.orderPages;
            const number = this.copy.pageNumber ? parseInt(this.copy.pageNumber) : '';

            let image = {
                productImages: this.images
            }

            if(number != 0 && number != ''){

                const find = pages.find(x => x.number === number);

                if(find){

                    if(this.products.length > 0){

                        let product = [];
                    
                        this.products.forEach(element => {
                            product.push({product: element.id})
                        });
                            
                        this.$http.post(`order-pages/${find.id}/adds/multis/products`, product, {
                        headers: {

                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'

                        }})
                        .then(response => {

                            this.copiedProduct = true;
                            this.$parent.$parent.$parent.uncheckAllCheckboxes();

                        })
                        .catch(error =>{

                            console.error(error.response);
                            this.blockBtn = false;

                        })
                            
                        

                    }

                    if(this.images.length > 0){
                        
                        this.images.forEach(element => {

                            image = {
                                productImage: element.id
                            }
                            
                            this.$http.post(`order-pages/${find.id}/adds/products/images`, image, {
                            headers: {

                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'

                            }})
                            .then(response => {

                                this.copiedProduct = true;
                                this.$parent.$parent.$parent.uncheckAllCheckboxes();

                            })
                            .catch(error =>{

                                console.error(error.response);
                                this.blockBtn = false;

                            })
                        
                        });

                    }

                }

                setTimeout(()=>{
                    this.$emit('cancel');
                }, 1000)

            }else{

                if(this.products.length > 0){
                
                    let product = [];
                        
                    this.products.forEach(element => {
                        product.push(element.id)
                    });
                            
                    this.$http.post(`orders/${this.copy.selectedOrderId}/multis/products/waitings`, product, {
                    headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'

                    }})
                    .then(response => {

                        this.copiedProduct = true;
                        this.$parent.$parent.$parent.uncheckAllCheckboxes();

                    })
                    .catch(error =>{

                        console.error(error.response);
                        this.blockBtn = false;

                    })

                }

                if(this.images.length > 0){

                    this.$http.post(`orders/${this.copy.selectedOrderId}/copies/images`, image, {
                    headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'

                    }})
                    .then(response => {

                        this.copiedProduct = true;
                        this.$parent.$parent.$parent.uncheckAllCheckboxes();

                    })
                    .catch(error =>{

                        console.error(error.response);
                        this.blockBtn = false;

                    })

                }

                setTimeout(()=>{
                    this.$emit('cancel');
                }, 1000)

            }

        },

        newProduct(){

            const token = localStorage.getItem('auth_token');

            this.products.forEach(item=>{
            
                let toCopy = {
                    isTemporary: this.copy.temporary,
                    number: this.copy.number,
                }

                let copiedId;

                this.$http.post(`products/${item.id}/copies`, toCopy, {
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'

                }})
                .then(response => {

                copiedId = response.data.copiedProduct.id;
                    
                if(this.copy.temporary){

                    this.copy.number = response.data.copiedProduct.number
                
                        setTimeout(() =>{
                    
                            if(this.copy.pageNumber != ''){

                                this.copyToOtherPage(copiedId, this.copy.pageNumber)

                            }

                            if(this.copy.pageNumber == ''){

                                this.assignToOrder(copiedId);

                            }
                        
                        }, 2000)

                        return;

                }

                    if(this.copy.pageNumber != ''){

                        this.copyToOtherPage(copiedId, this.copy.pageNumber)

                    }

                    if(this.copy.pageNumber == ''){

                        this.assignToOrder(copiedId);

                    } 

                })
                .catch(error =>{

                    console.error(error.response);
                    this.blockBtn = false;

                })

            })
        },

        assignToOrder(id){

            const token = localStorage.getItem('auth_token');
                        
            this.$http.post(`orders/${this.orderId}/products/${id}/waitings`, '', {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                this.copiedProduct = true;
                this.$parent.$parent.getOrder();
                this.$parent.manager();

                this.$parent.$parent.$parent.uncheckAllCheckboxes();
                setTimeout(()=>{
                    this.$emit('cancel');
                }, 1000)

            })
            .catch(error =>{

                console.error(error.response);
                this.blockBtn = false;

            })

        },

        copyToOtherPage(copiedId, copiedPage){

            if(this.products.length > 0){

                const pages = this.$parent.$parent.order.orderPages;
                let number = parseInt(this.copy.pageNumber);

                if(copiedPage){
                    number = parseInt(copiedPage);
                }

                const token = localStorage.getItem('auth_token');

                const find = pages.find(x => x.number === number);

                if(find){

                    if(copiedPage){
                    
                        let product = {
                            product: copiedId
                        }
                        
                        this.$http.post(`order-pages/${find.id}/adds/products`, product, {
                        headers: {

                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'

                        }})
                        .then(response => {

                            this.copiedProduct = true;
                            this.$parent.$parent.getOrder();
                            this.$parent.manager();
                            this.$parent.$parent.$parent.uncheckAllCheckboxes();
                            setTimeout(()=>{
                                this.$emit('cancel');
                            }, 1000)

                        })
                        .catch(error =>{

                            console.error(error.response);
                            this.blockBtn = false;

                        })

                    }else{

                        this.products.forEach(element => {

                            let product = {
                                product: element.id
                            }
                            
                            this.$http.post(`order-pages/${find.id}/adds/products`, product, {
                            headers: {

                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'

                            }})
                            .then(response => {

                                this.copiedProduct = true;
                                this.$parent.$parent.getOrder();
                                this.$parent.$parent.$parent.uncheckAllCheckboxes();
                                setTimeout(()=>{
                                    this.$emit('cancel');
                                }, 1000)

                            })
                            .catch(error =>{

                                console.error(error.response);
                                this.blockBtn = false;

                            })
                            
                        });

                    }

                }

            }

        },

        otherOrderPage(){

            if(this.pageId == 0){
                this.noPage = true;
                return;
            }

            const products = {
                sourceOrderPages: this.selectedPages
            }

            if(this.pageId != 0){

                const token = localStorage.getItem('auth_token');
                
                this.$http.post(`orders/${this.orderId}/copies/${this.copy.selectedOrderId}/pages`, products, {
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'

                }})
                .then(response => {
                
                    this.copied = true;
                    setTimeout(()=>{
                        this.$emit('cancel');
                    }, 1000)

                })
                .catch(error =>{

                    console.error(error.response);
                    this.addedProduct = [];
                    this.blockBtn = false;

                })

            }

        },

        close(e){

            if(!e.target.classList.contains('select-search') && !e.target.classList.contains('custom-search-input')){

                let lists = document.querySelectorAll('.select-search');

                if(lists){
                    lists.forEach(element => {
                        element.classList.remove('active')
                    });
                }

            }

        },

        blockFields(){

            this.disable = {
                temporary: false,
                search: false,
                number: false,
                page: false,
                currentOrder: false,
            };

            if(!this.pageOnly){
            
                if(this.products.length == 0 && this.images.length == 0){
                    
                    this.disable.temporary = true;
                    this.disable.search = true;
                    this.disable.number = true;
                    this.disable.page = true;

                }

                if(this.products.length > 1){
                    
                    this.disable.temporary = true;
                    this.disable.number = true;

                }

                if(this.images.length > 0){
                    
                    this.disable.temporary = true;
                    this.disable.number = true;

                }

                if(this.$parent.$parent.checkCentralUser()){

                    this.disable.currentOrder = true;
                    this.otherOrder = true;
                    this.checkBox('other', true);

                }

                if(this.currentOrder){
                    
                    this.disable.search = true;

                }

                if(this.otherOrder){
                    
                    this.disable.temporary = true;

                }

            }

        },

        copyImageToOtherPage(copiedId, copiedPage){

            const pages = this.$parent.$parent.order.orderPages;
            let number = parseInt(this.copy.pageNumber);

            if(copiedPage){
                number = parseInt(copiedPage);
            }

            const token = localStorage.getItem('auth_token');

            const find = pages.find(x => x.number === number);

            if(find){

                if(copiedPage){
                
                    let image = {
                        productImages: this.images
                    }
                    
                    this.$http.post(`orders/${find.id}/adds/products`, image, {
                    headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'

                    }})
                    .then(response => {

                        this.copiedProduct = true;
                        this.$parent.$parent.getOrder();
                        this.$parent.manager();
                        this.$parent.$parent.$parent.uncheckAllCheckboxes();
                        setTimeout(()=>{
                            this.$emit('cancel');
                        }, 1000)

                    })
                    .catch(error =>{

                        console.error(error.response);
                        this.blockBtn = false;

                    })

                    return;

                }

                    let image = {
                        productImages: this.images,
                    }
                    
                    this.$http.post(`order-pages/${find.id}/copies/images`, image, {
                    headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'

                    }})
                    .then(response => {

                        this.copiedProduct = true;
                        this.$parent.$parent.getOrder();
                        this.$parent.manager();
                        this.$parent.$parent.$parent.uncheckAllCheckboxes();
                        setTimeout(()=>{
                            this.$emit('cancel');
                        }, 1000)

                    })
                    .catch(error =>{

                        console.error(error.response);
                        this.blockBtn = false;

                    })

            }else{

                let image = {
                    productImages: this.images,
                }
                        
                this.$http.post(`orders/${this.orderId}/copies/images`, image, {
                headers: {

                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'

                }})
                .then(response => {

                    this.copiedProduct = true;
                        this.$parent.$parent.getOrder();
                        this.$parent.manager();
                        this.$parent.$parent.$parent.uncheckAllCheckboxes();
                        setTimeout(()=>{
                            this.$emit('cancel');
                        }, 1000)

                })
                .catch(error =>{

                    console.error(error.response);
                    this.blockBtn = false;

                })

            }

        },

    },
    mounted(){

        this.products = this.selectedItems.filter(o => o.rowType !== 'image');
        this.images = this.selectedItems.filter(o => o.rowType !== 'product');
        this.getFormData();

        if(this.selectedPages.length > 0 && this.selectedItems.length == 0){
            this.pageOnly = true;
        }

        this.blockFields();


    }

}
</script>

<style lang="scss" scoped>

.copy-popup-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 200;
}

.popup-group{
    display:flex;

    &__column{
        display:flex;
        flex-direction: column;

        &:nth-child(1){
            width: 7%;
        }

        &:nth-child(2){
            width: 87%;
        }
    }
}

.copy-popup{
  background:#fff;
  border: 1px #d3020c solid;
  width: 600px;

  &__body{
    padding: 20px 10px;
    position:relative;
    display:flex;
    flex-direction: column;

    & h1{
        font-size: 14px;
        font-weight: 400;
        color:#000000;
        opacity: 1;
        margin-bottom: 30px;
    }

    & label{
        font-size: 9px;
        margin-bottom:5px;
    }

     & .form-group{
         width:100%;
     }

    & .form-group.page{
        width:50px;
    }

    & .form-group > input{
        font-size: 14px;
        color:#000000;
        opacity:1;
        font-weight: 400;
    }

    & p{
        font-size: 12px;
        color:#E3000B;
    }

    & .checkbox{
        margin-bottom:0px
    }

  }

  &__footer{
      width:80%;
      display:flex;
      flex-direction: column;
      margin:0 auto;
      margin-top: 20px;

      & button{
          margin-bottom: 15px;
          height:56px;
      }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      zoom: 0.9;
    }
}

.select-search{
    position: absolute;
    left: 0;
    margin-bottom: -20px;
    width: auto;
    background: #fff;
    z-index: 3;
    max-height: 400px;
    overflow-x: hidden;
    cursor:pointer;
    visibility: hidden;

    &.active{
        visibility: visible;
    }

    & ul{
        list-style: none;
        padding:0;
        margin:0;

        & li{
            padding:10px 5px;
            &:nth-child(odd){
                background:#edf7ff
            }
        }
    }

    &::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgba(226, 229, 235, 0.5);
  }

  &::-webkit-scrollbar{
    width: 5px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    height:50px;
    background-color: #B1B4C1;
  }
}

.disabled-option{
    pointer-events: none;
    opacity: 0.5;
}

.custom-search-input{
    padding-right: 25px;
}

.col-temporary{
    flex-direction: column-reverse;
    display: flex;

    & label{
        font-size: 14px;
    }
}

.form-group.input-error > input {
  height: auto !important;
  padding-bottom: 0 !important;
}

.row-checkboxes{
    padding: 10px 0px;
    
    & label{
        font-size: 12px;
        opacity:1;
    }
}

</style>
